"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

var _likertStress = _interopRequireDefault(require("../options/likertStress.json"));

var _numDays = _interopRequireDefault(require("../options/numDays.json"));

var _days = _interopRequireDefault(require("../options/days28.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.SICK;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: ""
};
var workabilityQuestions = [{
  prompt: "On how many days in the last 4 weeks did your symptoms cause you to miss work for the full working day?",
  options: _days["default"],
  type: "slider"
}, {
  prompt: "On how many days in the last 4 weeks did your symptoms cause you to miss work ​for part of the working day?",
  options: _days["default"],
  type: "slider"
}, // {
// 	prompt:
// 		"During the past seven days, how much did your stress or health problems affect your productivity regarding work?",
// 	options: likertStress,
// 	type: "slider"
// },
{
  prompt: "On how many days in the last 4 weeks did you feel so impaired by your symptoms, that even though you went to work, your productivity was reduced?",
  options: _days["default"],
  type: "slider"
}];
var questions = (0, _utils.wrapBattery)(workabilityQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers));
  return {
    SICK: score,
    SICK_1: answers[0],
    SICK_2: answers[1],
    SICK_3: answers[2],
    SICK_4: answers[3]
  };
}